module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_mail_white.83c0729c.svg";